import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import toast from 'react-hot-toast'
import { Button } from '../../common/components/Button'
import styled from '@emotion/styled'
import { Row } from '../../common/components/Row'
import { Backdrop } from '../../common/components/Backdrop'
import { useInitChat } from '../hooks/useInitChat'

const Container = styled(Row)(({ theme }) => ({
  gap: theme.spacing.md,
}))

const Btn = styled(Button)({
  whiteSpace: 'nowrap',
})

export const ChatStateDeactivatedToast: FC = () => {
  const initChat = useInitChat()
  const { t } = useTranslation()

  useEffect(() => {
    const content = (
      <Container>
        <div>{t('Chat is inactive')}</div>

        <Btn
          primary
          onClick={() => {
            initChat()
          }}
        >
          {t('Connect again')}
        </Btn>
      </Container>
    )

    const toastId = toast(content, {
      duration: Infinity,
    })

    return () => {
      toast.dismiss(toastId)
    }
  }, [initChat, t])

  return <Backdrop />
}
